(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[108],{

/***/ 63866:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[cid]/[id]",
      function () {
        return __webpack_require__(17688);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(87066);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62019);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2962);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88518);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31788);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var src_components_layouts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75519);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(186);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15072);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(38864);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(39334);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84233);
/* harmony import */ var src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(84920);
/* harmony import */ var src_utils_contents_set_ads__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(69901);
/* harmony import */ var src_utils_contents_set_contents__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(84064);
/* harmony import */ var src_utils_device__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25283);
/* harmony import */ var src_utils_devices__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97348);
/* harmony import */ var src_utils_useUser__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(51148);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 72px;\n  @media (max-width: 1024px) {\n    min-height: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: var(--background-color);\n  margin: 0;\n  padding-bottom: 30px;\n  @media (max-width: 767px) {\n    padding-top: 90px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  min-height: 300px;\n  max-width: 1280px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgb(245, 245, 245);\n  & .block-ads-billboard {\n    width: 100%;\n    min-height: 300px;\n  }\n\n  @media (max-width: 767px) {\n    min-height: 350px;\n    & .block-ads-billboard {\n      min-height: 350px;\n    }\n  }\n\n  ",
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















// Moved to dynamic imports below

// Moved to dynamic import below







// Lazy load components to reduce initial bundle and improve INP
var DynamicAds = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return null;
    }
});
// ArticleDefault must be SSR-enabled for LCP image discoverability
var SectionLandingPageForArticle = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return __webpack_require__.e(/* import() */ 2815).then(__webpack_require__.bind(__webpack_require__, 62815));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62815)
            ];
        }
    },
    ssr: false
});
var ArticleDefaultLazy = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return __webpack_require__.e(/* import() */ 7815).then(__webpack_require__.bind(__webpack_require__, 57815));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57815)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            style: {
                minHeight: "400px"
            }
        });
    }
});
var WidgetStickyContentsLazy = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2285), __webpack_require__.e(3760)]).then(__webpack_require__.bind(__webpack_require__, 83760));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83760)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WidgetStickyPlaceholder, {});
    }
});
var SectionAffiliateLazy = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(6066), __webpack_require__.e(4929)]).then(__webpack_require__.bind(__webpack_require__, 34929));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34929)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return null;
    }
});
var PageCategoryDetail = function(props) {
    var getScrollTop = // handleCommemorate
    function getScrollTop() {
        if (typeof window.pageYOffset !== "undefined") {
            // Most browsers
            return window.pageYOffset;
        }
        var d = document.documentElement;
        if (typeof d.clientHeight !== "undefined") {
            // IE in standards mode
            return d.scrollTop;
        }
        // IE in quirks mode
        return document.body.scrollTop;
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var article = props.article, related = props.related, lastNews = props.lastNews, isTranslated = props.isTranslated, dataAffiliate = props.dataAffiliate, dataAdsNative = props.dataAdsNative, ads = props.ads, dataAdsHeader = props.dataAdsHeader, dataLandingPage = props.dataLandingPage, navData = props.navData;
    var _data = (0,src_utils_useUser__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)();
    var sessionSevId = (_data === null || _data === void 0 ? void 0 : _data.user) ? (0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_17__/* .decryptionClient */ .F)(_data === null || _data === void 0 ? void 0 : _data.user) : null;
    // const userId = getCookie('pdpa_user_id');
    // const userId = getCookie('pdpa_user_id');
    // const interactionSent = useRef(false);
    if (!article) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_10__["default"], {
            dataAdsHeader: dataAdsHeader,
            sessionSevId: sessionSevId
        });
    }
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), isTranslate = ref11[0], setIsTranslate = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(true), isKeyPoint = ref12[0], setIsKeyPoint = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)("TH"), selectLang = ref13[0], setSelectLang = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, article)), newsArticle = ref14[0], setNewsArticle = ref14[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var responsive = (0,src_utils_devices__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)();
    // const isDesktop = useDesktop();
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(true), adsBox = ref15[0], setAdsBox = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), isLoading = ref16[0], setIsLoading = ref16[1];
    var isDesktop = (0,src_utils_device__WEBPACK_IMPORTED_MODULE_19__/* .useDesktop */ .Ln)();
    var isStickyAdCategory = src_constants__WEBPACK_IMPORTED_MODULE_13__/* .STICKY_AD_CATEGORIES */ .Zj === null || src_constants__WEBPACK_IMPORTED_MODULE_13__/* .STICKY_AD_CATEGORIES */ .Zj === void 0 ? void 0 : src_constants__WEBPACK_IMPORTED_MODULE_13__/* .STICKY_AD_CATEGORIES.includes */ .Zj.includes(article === null || article === void 0 ? void 0 : (ref = article.section) === null || ref === void 0 ? void 0 : ref.en);
    var sentinelRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null); // sentinel วางไว้เหนือ billboard เพื่อดักจับจังหวะ "เริ่ม stick"
    var stickyTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    var hasStuckRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(false);
    var isStuckRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(false);
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(0), stickyMenuHeight = ref17[0], setStickyMenuHeight = ref17[1]; // ความสูงเมนู sticky เดิม
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), isReleased = ref18[0], setIsReleased = ref18[1]; // true = ปลด sticky หลังครบ 5 วิ
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), isStuck = ref19[0], setIsStuck = ref19[1];
    var adsRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(null), adsHeight = ref20[0], setAdsHeight = ref20[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        isStuckRef.current = isStuck && !isReleased;
    }, [
        isStuck,
        isReleased
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        var headerEl = document.querySelector(".header-desktop");
        var updateMenuHeight = function() {
            return setStickyMenuHeight(headerEl ? headerEl.offsetHeight : 0);
        };
        updateMenuHeight();
        window.addEventListener("resize", updateMenuHeight);
        return function() {
            return window.removeEventListener("resize", updateMenuHeight);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (!adsRef.current) return;
        var ro = new ResizeObserver(function(entries) {
            var ref, ref1;
            if (isStuckRef.current) return;
            var h = (ref = entries[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.contentRect) === null || ref1 === void 0 ? void 0 : ref1.height;
            if (h && h > 0) setAdsHeight(h);
        });
        ro.observe(adsRef.current);
        return function() {
            return ro.disconnect();
        };
    }, [
        ads
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (!isDesktop || !isStickyAdCategory || !sentinelRef.current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (!entry.isIntersecting) {
                if (!hasStuckRef.current) {
                    hasStuckRef.current = true;
                    setIsStuck(true);
                    setIsReleased(false);
                    if (stickyTimeoutRef.current) clearTimeout(stickyTimeoutRef.current);
                    stickyTimeoutRef.current = setTimeout(function() {
                        setIsReleased(true);
                        setIsStuck(false);
                    }, src_constants__WEBPACK_IMPORTED_MODULE_13__/* .STICKY_AD_DURATION */ .GK);
                }
            } else {
                hasStuckRef.current = false;
                setIsStuck(false);
                setIsReleased(false);
                if (stickyTimeoutRef.current) {
                    clearTimeout(stickyTimeoutRef.current);
                    stickyTimeoutRef.current = null;
                }
            }
        }, {
            rootMargin: "-".concat(stickyMenuHeight, "px 0px 0px 0px"),
            threshold: 0
        });
        observer.observe(sentinelRef.current);
        return function() {
            observer.disconnect();
            if (stickyTimeoutRef.current) clearTimeout(stickyTimeoutRef.current);
        };
    }, [
        isDesktop,
        isStickyAdCategory,
        stickyMenuHeight
    ]);
    var handleLightBoxClick = function() {
        // Use requestAnimationFrame to defer state update
        requestAnimationFrame(function() {
            setAdsBox(false);
        });
    };
    // Memoize article object to prevent unnecessary recalculations
    var _article = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, article, newsArticle), {
            title: newsArticle === null || newsArticle === void 0 ? void 0 : (ref = newsArticle.meta) === null || ref === void 0 ? void 0 : ref.title,
            description: (newsArticle === null || newsArticle === void 0 ? void 0 : (ref1 = newsArticle.meta) === null || ref1 === void 0 ? void 0 : ref1.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_DESC */ .a0,
            keyword: (newsArticle === null || newsArticle === void 0 ? void 0 : (ref2 = newsArticle.meta) === null || ref2 === void 0 ? void 0 : ref2.keyword) || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_KEYWORD */ .kG,
            id: newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.id,
            link: newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.link,
            tags: newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.tags,
            section: newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.section,
            image_url: newsArticle === null || newsArticle === void 0 ? void 0 : (ref3 = newsArticle.meta) === null || ref3 === void 0 ? void 0 : ref3.og_social_image,
            subCategory: newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.subCategory
        });
    }, [
        article,
        newsArticle
    ]);
    // Load Instagram embed.js only when the article actually contains an IG embed (most don't) — saves a main-thread script parse → better INP
    var hasInstagramEmbed = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        var body = "".concat((_article === null || _article === void 0 ? void 0 : _article.content_I) || "").concat((_article === null || _article === void 0 ? void 0 : _article.content_II) || "");
        return body.includes("instagram.com") || body.includes("instagram-media");
    }, [
        _article === null || _article === void 0 ? void 0 : _article.content_I,
        _article === null || _article === void 0 ? void 0 : _article.content_II
    ]);
    // Memoize computed values
    var baseUrlCategory = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        return "".concat(_article === null || _article === void 0 ? void 0 : _article.canonical);
    }, [
        _article === null || _article === void 0 ? void 0 : _article.canonical
    ]);
    var articleTitle = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        return (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_15__/* .escapeChar */ .yf)(_article === null || _article === void 0 ? void 0 : _article.title);
    }, [
        _article === null || _article === void 0 ? void 0 : _article.title
    ]);
    // const categoryName = _article?.subCategory?.[isTranslate ? 'en' : 'th'] ? _article?.subCategory?.[isTranslate ? 'en' : 'th'] : _article?.section?.[isTranslate ? 'en' : 'th'];
    // const categoryPath = _article?.subCategory?.en ? `${_article?.section?.en}/${_article?.subCategory?.en}` : _article?.section?.en;
    /* -------------------------------- DATALAYER ------------------------------- */ // const nextSectionIndexRef = useRef(0);
    // const sectionsVisibleRef = useRef([]);
    // const sectionRef = useRef(null);
    // const footerRef = useRef(false);
    var handleTranslate = (0,react__WEBPACK_IMPORTED_MODULE_11__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(function(newLanguage) {
            var ref, ref1, uriToken, getToken, _tmp, _tmp1, ref2, ref3, ref4, ref5, ref6, uriEn, translate, _tmp2, _tmp3, _tmp4, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_26__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isLoading) return [
                            2
                        ];
                        // Immediate UI feedback - batch state updates
                        setSelectLang(newLanguage);
                        setIsTranslate(function(prev) {
                            return !prev;
                        });
                        setIsKeyPoint(false);
                        // Defer heavy operations
                        requestAnimationFrame(function() {
                            setIsLoading(true);
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        if (!(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .NEXT_PUBLIC_URL_SOUND */ .O6 !== undefined || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(_article === null || _article === void 0 ? void 0 : _article.id))) return [
                            3,
                            5
                        ];
                        uriToken = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .NEXT_PUBLIC_URL_SOUND */ .O6, "/create");
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_27__/* ["default"].post */ .Z.post(uriToken, (_tmp.app = "default", _tmp), (_tmp1.headers = {
                                "Content-Type": "application/json",
                                "User-Agents": "NationSpeech/1.0 ".concat(props === null || props === void 0 ? void 0 : props.agent)
                            }, _tmp1)).catch(function(error) {
                                console.error(error);
                            })
                        ];
                    case 2:
                        getToken = _state.sent();
                        if (!((getToken === null || getToken === void 0 ? void 0 : (ref = getToken.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.token) !== undefined)) return [
                            3,
                            5
                        ];
                        uriEn = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .NEXT_PUBLIC_URL_SOUND */ .O6, "/translates/").concat(_article === null || _article === void 0 ? void 0 : _article.id, "/").concat(newLanguage);
                        _tmp2 = {};
                        _tmp3 = {};
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_27__/* ["default"].post */ .Z.post(uriEn, (_tmp2.data = {
                                id: _article === null || _article === void 0 ? void 0 : _article.id,
                                site: src_constants__WEBPACK_IMPORTED_MODULE_13__/* .NEXT_PUBLIC_WEB_NAME_SOUND */ .js,
                                language: newLanguage
                            }, _tmp2), (_tmp3.headers = {
                                "Content-Type": "application/json",
                                "User-Agents": "NationSpeech/1.0 ".concat(props === null || props === void 0 ? void 0 : props.agent),
                                accessToken: getToken === null || getToken === void 0 ? void 0 : (ref2 = getToken.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.token,
                                accessTimeStamp: getToken === null || getToken === void 0 ? void 0 : (ref4 = getToken.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.timestamp
                            }, _tmp3)).catch(function(error) {
                                console.error(error);
                            })
                        ];
                    case 3:
                        translate = _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 500);
                            })
                        ];
                    case 4:
                        _state.sent();
                        _tmp4 = {};
                        setNewsArticle((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_tmp4, article, translate === null || translate === void 0 ? void 0 : (ref6 = translate.data) === null || ref6 === void 0 ? void 0 : ref6.data));
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        error = _state.sent();
                        setIsLoading(true);
                        console.log(error, "Error Translate ");
                        return [
                            3,
                            8
                        ];
                    case 7:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(newLanguage) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isLoading,
        _article === null || _article === void 0 ? void 0 : _article.id,
        article,
        props === null || props === void 0 ? void 0 : props.agent
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        // Defer non-critical localStorage operations
        var timer = setTimeout(function() {
            try {
                localStorage.setItem("_t", "0");
                var timeCount = 0;
                var increment = function() {
                    timeCount += 1;
                    // อัพเดท localStorage ทุก 30 วินาทีเพื่อลด overhead
                    if (timeCount % 30 === 0) {
                        localStorage.setItem("_t", timeCount.toString());
                    }
                };
                var intervalId = setInterval(increment, 1000);
                return function() {
                    return clearInterval(intervalId);
                };
            } catch (err) {
                console.log("Error: Please enable website cookies. " + err);
            }
        }, 2000); // Defer by 2 seconds
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        // Defer non-critical operations using requestIdleCallback
        if ("requestIdleCallback" in window) {
            requestIdleCallback(function() {
                Number(_article === null || _article === void 0 ? void 0 : _article.id) > Number(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_IMAGE_DESC_ID */ .lO) && (0,src_utils_contents_set_contents__WEBPACK_IMPORTED_MODULE_28__/* .setContents */ .i)();
                (0,src_utils_contents_set_ads__WEBPACK_IMPORTED_MODULE_29__/* .setAds */ .c)();
            });
        } else {
            // Fallback for browsers without requestIdleCallback
            setTimeout(function() {
                Number(_article === null || _article === void 0 ? void 0 : _article.id) > Number(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_IMAGE_DESC_ID */ .lO) && (0,src_utils_contents_set_contents__WEBPACK_IMPORTED_MODULE_28__/* .setContents */ .i)();
                (0,src_utils_contents_set_ads__WEBPACK_IMPORTED_MODULE_29__/* .setAds */ .c)();
            }, 100);
        }
        // Defer analytics call - fire and forget, no state update needed
        var fetchCountView = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(function() {
                var params, _tmp, _tmp1, err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_26__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            params = (_tmp.site = "bangkokbiznews", _tmp.newsid = _article.id, _tmp);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _tmp1 = {};
                            return [
                                4,
                                fetch("".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .CLIENT_GSERVICE_URL */ .Tr, "/cpvs"), (_tmp1.method = "POST", _tmp1.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp1.body = JSON.stringify(params), _tmp1))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchCountView() {
                return _ref.apply(this, arguments);
            };
        }();
        // Defer by 3 seconds to not block main thread
        var timer = setTimeout(fetchCountView, 3000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        _article.id
    ]);
    // Memoize media query to prevent recalculation
    var isMb = (0,react_responsive__WEBPACK_IMPORTED_MODULE_30__.useMediaQuery)({
        query: "(max-width: 768px)"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (!isMb) return;
        // Defer scroll listener setup
        var setupScrollListener = function() {
            var ticking = false;
            var lastScrollTop = 0;
            var threshold = 10; // Increase threshold to 10px for less frequent updates
            var boxCache = null;
            var boxJsCache = null;
            var handleScroll = function() {
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(function() {
                        var scroll = getScrollTop();
                        // Only update if scroll changed significantly
                        if (Math.abs(scroll - lastScrollTop) < threshold) {
                            ticking = false;
                            return;
                        }
                        lastScrollTop = scroll;
                        // Cache DOM queries
                        if (!boxCache) boxCache = document.getElementById("widget-group");
                        if (!boxJsCache) boxJsCache = document.getElementById("widget-group-js");
                        if (boxCache || boxJsCache) {
                            var topValue = scroll <= 20 ? "112px" : "70px";
                            if (boxCache) boxCache.style.top = topValue;
                            if (boxJsCache) boxJsCache.style.top = topValue;
                        }
                        ticking = false;
                    });
                }
            };
            window.addEventListener("scroll", handleScroll, {
                passive: true
            });
            return function() {
                return window.removeEventListener("scroll", handleScroll);
            };
        };
        // Defer setup by 1.5 seconds
        var timer = setTimeout(setupScrollListener, 1500);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isMb
    ]);
    // Memoize authors array to prevent recreation on every render
    var authors = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        return [
            {
                "@type": (article === null || article === void 0 ? void 0 : article.byline) ? "Person" : "Organization",
                name: (article === null || article === void 0 ? void 0 : article.byline) || "กรุงเทพธุรกิจ",
                url: (article === null || article === void 0 ? void 0 : article.byline) ? src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX + "/bylines/" + (article === null || article === void 0 ? void 0 : article.byline) : src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX + "/bylines/" + "กรุงเทพธุรกิจ"
            }
        ];
    }, [
        article === null || article === void 0 ? void 0 : article.created_by
    ]);
    var articleDescription = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        return (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_15__/* .escapeChar */ .yf)(_article === null || _article === void 0 ? void 0 : _article.description);
    }, [
        _article === null || _article === void 0 ? void 0 : _article.description
    ]);
    var isAnalysisSection = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        var ref, ref1;
        return (ref = [
            "economics",
            "business"
        ]) === null || ref === void 0 ? void 0 : ref.includes(_article === null || _article === void 0 ? void 0 : (ref1 = _article.section) === null || ref1 === void 0 ? void 0 : ref1.en);
    }, [
        _article === null || _article === void 0 ? void 0 : (ref1 = _article.section) === null || ref1 === void 0 ? void 0 : ref1.en
    ]);
    var sectionCapitalized = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        var ref, ref1;
        var s = (_article === null || _article === void 0 ? void 0 : (ref = _article.section) === null || ref === void 0 ? void 0 : ref.en) || "";
        return ((ref1 = s.charAt(0)) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()) + (s === null || s === void 0 ? void 0 : s.slice(1));
    }, [
        _article === null || _article === void 0 ? void 0 : (ref2 = _article.section) === null || ref2 === void 0 ? void 0 : ref2.en
    ]);
    var analysisSchemaFields = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        if (!isAnalysisSection) return "";
        return '\n                  "articleSection": "'.concat(sectionCapitalized, '",\n                  "about": [\n                    {\n                      "@type": "Thing",\n                      "name": "').concat(sectionCapitalized, ' Analysis"\n                    }\n                  ],');
    }, [
        isAnalysisSection,
        sectionCapitalized
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_5__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), {
                title: _article === null || _article === void 0 ? void 0 : _article.title,
                description: _article === null || _article === void 0 ? void 0 : _article.description,
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                },
                openGraph: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"].openGraph */ .Z.openGraph), {
                    title: _article === null || _article === void 0 ? void 0 : _article.title,
                    description: _article === null || _article === void 0 ? void 0 : _article.description,
                    url: baseUrlCategory,
                    article: {
                        publishedTime: _article === null || _article === void 0 ? void 0 : _article.published_at,
                        modifiedTime: _article === null || _article === void 0 ? void 0 : _article.updated_at,
                        expirationTime: null,
                        section: _article === null || _article === void 0 ? void 0 : (ref3 = _article.section) === null || ref3 === void 0 ? void 0 : ref3.th,
                        authors: [
                            "".concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.FACEBOOK */ .h$.FACEBOOK)
                        ],
                        tags: _article === null || _article === void 0 ? void 0 : _article.tags
                    },
                    images: [
                        {
                            url: _article === null || _article === void 0 ? void 0 : _article.image_url,
                            width: "1200",
                            height: "675",
                            alt: _article === null || _article === void 0 ? void 0 : _article.title
                        }
                    ]
                }),
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: _article === null || _article === void 0 ? void 0 : _article.keyword
                    }
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "canonical",
                        href: baseUrlCategory
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "dns-prefetch",
                        href: "//securepubads.g.doubleclick.net"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "dns-prefetch",
                        href: "//www.googletagservices.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "dns-prefetch",
                        href: "//www.instagram.com"
                    }),
                    (_article === null || _article === void 0 ? void 0 : _article.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_IMG */ .T).concat(_article.image, "?x-image-process=style/LG-webp"),
                        type: "image/webp",
                        fetchpriority: "high"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "preload",
                        as: "font",
                        type: "font/woff2",
                        href: "https://fonts.gstatic.com/s/sarabun/v17/DtVmJx26TKEr37c9YL5rik8s6yLUrwB0lw.woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "preload",
                        as: "font",
                        type: "font/woff2",
                        href: "https://fonts.gstatic.com/s/sarabun/v17/DtVmJx26TKEr37c9YL5rilss6yLUrwA.woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "preload",
                        as: "font",
                        type: "font/woff2",
                        href: "https://fonts.gstatic.com/s/sarabun/v17/DtVjJx26TKEr37c9aAFJn3YO5gjupg.woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "preload",
                        as: "font",
                        type: "font/woff2",
                        href: "https://fonts.gstatic.com/s/sarabun/v17/DtVjJx26TKEr37c9aBVJn3YO5gg.woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:title",
                        content: (_article === null || _article === void 0 ? void 0 : _article.title) || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_TITLE */ .qN
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:description",
                        content: (_article === null || _article === void 0 ? void 0 : _article.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_DESC */ .a0
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:image",
                        content: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(_article === null || _article === void 0 ? void 0 : _article.image) ? "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_IMG */ .T).concat(_article === null || _article === void 0 ? void 0 : _article.image) : src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .IMAGE_DEFAULT */ .TH
                    }),
                    !(0,src_utils_device__WEBPACK_IMPORTED_MODULE_19__/* .useDesktop */ .Ln)() && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,src_utils_device__WEBPACK_IMPORTED_MODULE_19__/* .useDesktop */ .Ln)() && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        async: true,
                        defer: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        defer: true,
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n                __th_page="'.concat(_article === null || _article === void 0 ? void 0 : (ref4 = _article.section) === null || ref4 === void 0 ? void 0 : ref4.en, '";\n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n                {\n                  "@context": "https://schema.org",\n                  "@type": "WebSite",\n                  "name": "'.concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_NAME */ .Ey, '",\n                  "url": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.WEB */ .h$.WEB, '",\n                  "description": "').concat(articleDescription || src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_DESC */ .a0, '",\n                  "sameAs": [\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.FACEBOOK */ .h$.FACEBOOK, '",\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.TWITTER */ .h$.TWITTER, '",\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.INSTAGRAM */ .h$.INSTAGRAM, '",\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.YOUTUBE */ .h$.YOUTUBE, '",\n                    "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.LINE */ .h$.LINE, '"\n                  ],\n                  "potentialAction": {\n                    "@type": "SearchAction",\n                    "target": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_URL.WEB */ .h$.WEB, 'search?q={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                }\n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: ' \n                { \n                  "@context": "http://schema.org", \n                  "@type": "WebPage", \n                  "name": "'.concat(articleTitle, '", \n                  "description": "').concat(articleDescription, '", \n                  "publisher": { \n                    "@type": "ProfilePage", \n                    "name": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_NAME */ .Ey, '" \n                  } \n                } \n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: ' \n                { \n                  "@context": "http://schema.org", \n                  "@type": "BreadcrumbList", \n                  "itemListElement": [ \n                    { \n                      "@type": "ListItem", \n                      "position": 1, \n                      "name": "หน้าแรก", \n                      "item": "'.concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX, '" \n                    }, \n                    { \n                      "@type": "ListItem", \n                      "position": 2, \n                      "name": "').concat(_article === null || _article === void 0 ? void 0 : (ref5 = _article.section) === null || ref5 === void 0 ? void 0 : ref5.th, '", \n                      "item": "').concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX, "/").concat(_article === null || _article === void 0 ? void 0 : (ref6 = _article.section) === null || ref6 === void 0 ? void 0 : ref6.en, '" \n                    }, \n                    { \n                      "@type": "ListItem", \n                      "position": 3, \n                      "name": "').concat(articleTitle, '", \n                      "item": "').concat((_article === null || _article === void 0 ? void 0 : _article.canonical) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(_article === null || _article === void 0 ? void 0 : _article.link) && "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX).concat(_article === null || _article === void 0 ? void 0 : _article.link) || "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX, "/").concat(_article === null || _article === void 0 ? void 0 : (ref7 = _article.section) === null || ref7 === void 0 ? void 0 : ref7.en, "/").concat(_article === null || _article === void 0 ? void 0 : _article.id), '" \n                    } \n                  ] \n                } \n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: ' \n                { \n                  "@context": "http://schema.org", \n                  "@type": "'.concat((_article === null || _article === void 0 ? void 0 : (ref8 = _article.section) === null || ref8 === void 0 ? void 0 : ref8.en) === "economics" || (_article === null || _article === void 0 ? void 0 : (ref9 = _article.section) === null || ref9 === void 0 ? void 0 : ref9.en) === "business" ? "AnalysisNewsArticle" : "NewsArticle", '", \n                  "mainEntityOfPage": { \n                    "@type": "WebPage", \n                    "@id": "').concat((_article === null || _article === void 0 ? void 0 : _article.canonical) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(_article === null || _article === void 0 ? void 0 : _article.link) && "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX).concat(_article === null || _article === void 0 ? void 0 : _article.link) || "".concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_URL */ .FX, "/").concat(_article === null || _article === void 0 ? void 0 : (ref10 = _article.section) === null || ref10 === void 0 ? void 0 : ref10.en, "/").concat(_article === null || _article === void 0 ? void 0 : _article.id), '" \n                  }, \n                  "headline": "').concat(articleTitle, '", \n                  "alternativeHeadline": "').concat(articleTitle, '", \n                  "description": "').concat(articleDescription, '", ').concat(analysisSchemaFields, '\n                  "image": "').concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_IMG */ .T).concat(_article === null || _article === void 0 ? void 0 : _article.image, '", \n                  "datePublished": "').concat(_article === null || _article === void 0 ? void 0 : _article.published_at, '",\n                  "dateModified": "').concat(_article === null || _article === void 0 ? void 0 : _article.updated_at, '",\n                  "author": ').concat(JSON.stringify(authors), ', \n                  "publisher": { \n                    "@type": "Organization", \n                    "name": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .WEB_NAME */ .Ey, '", \n                    "logo": { \n                      "@type": "ImageObject", \n                      "url": "').concat(src_constants__WEBPACK_IMPORTED_MODULE_13__/* .APP_IMG */ .T, "/static/").concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_14__/* .STATIC_FILE.ICON_LOGO */ .Pc.ICON_LOGO, '" \n                    } \n                  } \n                } \n              ')
                        }
                    }),
                    hasInstagramEmbed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        async: true,
                        defer: true,
                        src: "//www.instagram.com/embed.js"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: dataLandingPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionLandingPageForArticle, {
                    data: dataLandingPage
                })
            }),
            !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(dataAffiliate) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionAffiliateLazy, {
                position: 4,
                data: dataAffiliate
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_16___default()), {
                id: "script-creden",
                strategy: "lazyOnload",
                src: "https://data.creden.co/js/detect_company_name.js?client_name=bangkokbiznews"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_layouts__WEBPACK_IMPORTED_MODULE_12__["default"], {
                ads: ads,
                sessionSevId: sessionSevId,
                navData: navData,
                children: [
                    (_article === null || _article === void 0 ? void 0 : _article.is_show_ads) && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.LIGHTBOX,
                        data: ads,
                        handler: function() {
                            return handleLightBoxClick();
                        },
                        adsBox: adsBox
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PageWrapper, {
                        id: "content-wrapper",
                        children: [
                            (_article === null || _article === void 0 ? void 0 : _article.is_show_ads) && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        ref: sentinelRef
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsReserveSpace, {
                                        className: "block-ads-billboard",
                                        ref: adsRef,
                                        $position: isDesktop && isStickyAdCategory && !isReleased,
                                        $pinned: isStuck && !isReleased,
                                        $fixedHeight: adsHeight,
                                        $topOffset: stickyMenuHeight,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                                            position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.BILLBOARD,
                                            data: ads
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArticleDefaultLazy, {
                                ads: ads,
                                dataAdsNative: dataAdsNative,
                                dataAffiliate: dataAffiliate,
                                lastNews: (responsive === null || responsive === void 0 ? void 0 : responsive.isMobile) ? lastNews === null || lastNews === void 0 ? void 0 : lastNews.slice(0, 3) : lastNews,
                                isKeyPoint: isKeyPoint,
                                related: related,
                                translated: isTranslated === true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WidgetStickyContentsLazy, {
                                    className: "block-sticky",
                                    isLoading: isLoading,
                                    article: article,
                                    handleTranslate: handleTranslate,
                                    selectLang: selectLang,
                                    router: router,
                                    isTranslated: isTranslated
                                }),
                                article: _article
                            })
                        ]
                    }),
                    (_article === null || _article === void 0 ? void 0 : _article.is_show_ads) && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.AD1X1,
                        data: ads
                    })
                ]
            })
        ]
    });
};
var WidgetStickyPlaceholder = styled_components__WEBPACK_IMPORTED_MODULE_31__["default"].div(_templateObject());
var PageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_31__["default"].div(_templateObject1());
var AdsReserveSpace = styled_components__WEBPACK_IMPORTED_MODULE_31__["default"].div(_templateObject2(), function(param) {
    var $position = param.$position, $topOffset = param.$topOffset;
    return $position && "\n      position: sticky;\n      top: ".concat($topOffset, "px;\n      z-index: 9;\n    ");
}, function(param) {
    var $fixedHeight = param.$fixedHeight;
    return $fixedHeight && "\n      min-height: ".concat($fixedHeight, "px;\n\n      & .block-ads-billboard {\n        min-height: ").concat($fixedHeight, "px;\n      }\n    ");
}, function(param) {
    var $pinned = param.$pinned;
    return $pinned && "\n    background: none;\n\n    & .block-ads-billboard {\n      background: none;\n    }\n  ";
});
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PageCategoryDetail);


/***/ }),

/***/ 97348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_1__);


var useResponsive = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isClient = ref[0], setIsClient = ref[1];
    var isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "690px"
    });
    var isTabletMini = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "767px"
    });
    var isLaptopMini = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "768px"
    });
    var isTablet = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "900px"
    });
    var isLaptop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "691px"
    });
    var isDesktop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "1024px"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (true) setIsClient(true);
    }, []);
    return {
        isDesktop: isClient ? isDesktop : true,
        isLaptop: isClient ? isLaptop : true,
        isTablet: isClient ? isTablet : false,
        isMobile: isClient ? isMobile : false,
        isTabletMini: isClient ? isTabletMini : false,
        isLaptopMini: isClient ? isLaptopMini : false
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useResponsive);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [601,7817,8764,9302,5921,9774,2888,179], function() { return __webpack_exec__(63866); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);